import { eAnimAssets, eModelAsset, eTextures, Game, rnd2 } from "../../Game";
import { Gameplay } from "../Gameplay";
import { RoundManager } from "../Round/RoundManager";
import { Ball } from "./Ball";



const enum ePlayerState {
    idle,
    kickOff,
}



export class Shooter {
    private static readonly BALL_OFFSET = new pc.Vec3(-1, -0.1, 2.7);

    /**
     * Casovy offset od zahajeni animace vykopnuti do doby, kdy hrac zasahne mic (ve vterinach)
     */
    static readonly BALL_KICKOFF_TIME_OFFSET = 21 / 30;

    static get instance(): Shooter { return Shooter._instance; }
    private static _instance: Shooter;

    private _entity: pc.Entity;
    private _state: ePlayerState;

    /**
     * Pozice nastave
     */
    get pos(): pc.Vec3 { return this._entity.getPosition(); }

    private _ballDis: number;
    private _ballAngle: number;

    /**
     * Celkovy pocet postav pro strelce
     */
    private static readonly CHAR_TOTAL_CNT = 3;
    private static readonly CHAR_MASK = 7;

    /**
     * Maska postav, ktere zbyva pouzit
     */
    private _charMask: number;
    /**
     * Prodleva v poctu kol do pouziti dalsi postavy
     */
    private _nextCharDelay: number;
    /**
     * (RO) Index aktualni postavy hrace
     */
    get charId(): number { return this._charId; }
    private _charId: number;

    /**
     * Modely postav
     */
    private _charModels: pc.Model[];
    /**
     * Textury pro jednotlive postavy
     */
    private _charTextures: pc.Texture[];
    /**
     * Index modelu pro jednotlive postavy
     */
    private _charModelId: number[];

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        Shooter._instance = this;

        let assets = Game.app.assets;

        // Modely
        this._charModels = [
            (assets.find(eModelAsset.character_1, pc.eAssetType.model).resource as pc.Model).clone(),
            (assets.find(eModelAsset.character_2, pc.eAssetType.model).resource as pc.Model).clone(),
        ];
        this._charModelId = [0, 1, 0];

        // Maska postav
        this._charMask = Shooter.CHAR_MASK;
        this._nextCharDelay = 0;

        // Entita postavy
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            castShadows: true,
            receiveShadows: false,
            static: false
        });
        this._entity.model.model = this._charModels[0];

        this._entity.addComponent(pc.eCompomentType.animation, {
            assets: [
                assets.find(eAnimAssets.playerIdle, pc.eAssetType.animation),
                assets.find(eAnimAssets.playerKickOff, pc.eAssetType.animation),
            ],
            speed: 1,
            activate: true,
            loop: true
        });
        Game.app.root.addChild(this._entity);

        // Textury pro postavy
        this._charTextures = [(this._entity.model.meshInstances[0].material as pc.StandardMaterial).diffuseMap];

        for (let i = 1; i < Shooter.CHAR_TOTAL_CNT; i++)
            this._charTextures[i] = Game.app.assets.find(eTextures.shooter + i, pc.eAssetType.texture).resource;

        // Vzdalenost a uhel hrace od mice
        this._ballDis = Math.sqrt(Math.pow(Shooter.BALL_OFFSET.x, 2) + Math.pow(Shooter.BALL_OFFSET.z, 2));
        this._ballAngle = Math.asin(Shooter.BALL_OFFSET.x / this._ballDis);

        // Cekat na vykopnuti mice
        Gameplay.instance.events.on(Ball.EVENT_KICKED_OFF1, this.handleBallKickOff, this);
    }

    //-------------------------------------------------------------------------
    /**
     * Pripravit hrace na vykopnuti
     */
    //-------------------------------------------------------------------------
    prepareKickOff(): void {
        let roundMng = RoundManager.instance;
        let roundSetup = roundMng.roundSetup;
        let pos = new pc.Vec3().copy(roundSetup.kickOffPos);
        let angle = roundSetup.goalCenterAngle - this._ballAngle;

        pos.x += Math.cos(angle) * this._ballDis;
        pos.z += Math.sin(angle) * this._ballDis;

        // Nastavit texturu hrace
        if (this._nextCharDelay-- == 0) {
            this._nextCharDelay = 2;

            // Vybrat novou postavu
            let charId = rnd2.randomIntIn(0, Shooter.CHAR_TOTAL_CNT - 1);

            if (this._charMask == 0)
                this._charMask = Shooter.CHAR_MASK;

            while ((this._charMask & (1 << charId)) == 0) {
                if (charId-- == 0)
                    charId = Shooter.CHAR_TOTAL_CNT - 1;
            }

            this._charMask &= ~(1 << charId);
            this._charId = charId;

            // Nastavit model
            this._entity.model.model = this._charModels[this._charModelId[charId]];

            // Nastavit texturu            
            this._entity.model.meshInstances[0].setParameter("texture_diffuseMap", this._charTextures[charId]);
        }


        this._entity.setPosition(pos);
        this._entity.setEulerAngles(0, 180 - roundSetup.goalCenterAngle * pc.math.RAD_TO_DEG + 90, 0);
        this._entity.animation.play(eAnimAssets.playerIdle);
        this._entity.animation.loop = true;

        this._state = ePlayerState.idle;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        /*if (this._state == ePlayerState.kickOff) {
            if (this._entity.animation.currentTime >= this._entity.animation.duration) {
                this._entity.animation.play(eAnimAssets.playerIdle);
                this._entity.animation.loop = true;

                this._state = ePlayerState.idle;
            }
        }*/
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleBallKickOff(): void {
        this._entity.animation.play(eAnimAssets.playerKickOff, 0.1);
        this._entity.animation.loop = false;

        this._state = ePlayerState.kickOff;
    }
}